class NotAcceptable extends Error {
  constructor(message = 'Not Acceptable. Server cannot produce a response matching the list of acceptable values defined in the request.'
    , acceptedValues = []) {
    let errorMessage = message
    if (acceptedValues && Array.isArray(acceptedValues) && acceptedValues.length > 0) {
      errorMessage = `${message}. Accepted values: ${acceptedValues.toString()}`
    }
    super(errorMessage)
    this.name = this.constructor.name
    this.status = 406
    Error.captureStackTrace(this, this.constructor)
  }
}

module.exports = NotAcceptable
